function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 21 18",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M20.042.38l-17.586 17H.042l17.585-17h2.415zm-.77 1.72A1.707 1.707 0 0120.4 3.7v10.2c0 .935-.765 1.7-1.7 1.7H5.563l.098-.097L7.289 13.9l1.22-1.2c.459.2.96.321 1.485.346l.206.005a4.252 4.252 0 003.925-5.88l3.08-3.173a.85.85 0 10.407-.263zM14.45 2l-2.803 2.803a4.252 4.252 0 00-5.444 5.445L1.002 15.45A1.706 1.706 0 010 13.9V3.7C0 2.765.765 2 1.7 2h12.751zm-1.562 6.387a2.72 2.72 0 01-3.144 3.095zM10.2 6.08c.056 0 .112.002.167.005L7.485 8.967A2.72 2.72 0 0110.2 6.08z",
  fill: "#575757",
  fillRule: "nonzero"
})));